<template>
	<div>
		<div v-if="hitungSisaBayar() === grandtotal">
			<div class="f-regular f-16 f-c-red">
				Belum Dibayar
			</div>
		</div>
		<div v-else>
			<div class="d-flex-between-center">
				<div class="f-regular f-16 f-c-black">
					Terbayar
				</div>
				<div class="f-regular f-16 f-c-black">
					{{ hitungTerbayar() | currency }}
				</div>
			</div>
			<div class="d-flex-between-center m-t-4" v-if="hitungKembalian() > 0">
				<div class="f-regular f-14 f-c-midgrey">
					Kembalian
				</div>
				<div class="f-regular f-14 f-c-midgrey">
					{{ hitungKembalian() | currency }}
				</div>
			</div>
			<div class="d-flex-between-center m-t-4" v-if="hitungSisaBayar() > 0">
				<div class="f-regular f-14 f-c-red">
					Sisa Bayar
				</div>
				<div class="f-regular f-14 f-c-red">
					{{ hitungSisaBayar() | currency }}
				</div>
			</div>
		</div>
		<div class="f-regular f-12 f-c-midgrey" v-if="pembayaran.filter(v => v.jenis_bayar === 11).length > 0">
			Termasuk biaya tambahan transaksi EDC
		</div>
	</div>
</template>

<script>
export default {
	name: "SOPembayaranTotalPembayaran",
	props: {
		grandtotal: Number,
		pembayaran: Array,
	},
	methods: {
		hitungTerbayar() {
			var terbayar = 0
			this.pembayaran.forEach(p => {
				terbayar += p.dibayar + p.kembalian // perbaikan ketika ada kembaliannya
				// terbayar += p.edc_biaya_transaks
			})
			return terbayar
		},
		hitungKembalian() {
			var kembalian = 0
			this.pembayaran.forEach(p => {
				kembalian += p.kembalian
			})
			return kembalian
		},
		hitungSisaBayar() {
			return this.grandtotal - this.hitungTerbayar()
		}
	}
}
</script>